import { NgModule } from '@angular/core';

import { MasterConsultaUsuariosActions } from './master-consulta-usuarios.actions';

@NgModule({
  providers: [
    MasterConsultaUsuariosActions
  ]
})
export class MasterConsultaUsuariosActionsModule {}
